export enum DateRanges {
  Today = 1,
  ThisWeek = 2,
  ThisMonth = 3,
  ThisYear = 4,
  Yesterday = 5,
  LastWeek = 6,
  LastMonth = 7,
  LastYear = 8,
  TwoMonths = 9,
  Last30Days = 10,
  Last60Days = 11,
  Last90Days = 12,
  CustomRange = 13,
  ThisFinancialYear = 14,
  ThisHMRCTaxYear = 15,
  ThisVATYear = 16,
  LastFinancialYear = 17,
  LastHMRCTaxYear = 18,
  LastVATYear = 19,
  ThisVATQuarter = 20,
  LastVATQuarter = 21,
  AllDates = 22,
  LastMonthLastYear = 23,
}
